import ResetearContrasenaCard from "components/ResetearContrasenaCard";
import "./styles.css";

const ResetearContrasena = () => {
  return (
    <div className="login-page-container">
      <ResetearContrasenaCard />
    </div>
  );
};

export default ResetearContrasena;
